import deburr from 'lodash/deburr'

export const searchString = (value: string, search: string) => {
  console.info(
    `Searching for "${search}" in "${value}"`,
    deburr(value).toLowerCase(),
    deburr(search).toLowerCase()
  )
  return deburr(value).toLowerCase().includes(deburr(search).toLowerCase())
}
